import {
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewEncapsulation,
} from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { DossierLastStepForm } from '@sc/commons';
import { DossierLastStepFormBottomSheetData } from '@sc/data-access-models';
import { DossierLastStepFormComponent } from '../dossier-last-step-form';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../icon';

@Component({
  selector: 'sc-dossier-last-step-form-bottom-sheet',
  styleUrls: ['./dossier-last-step-form-bottom-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="header-bottom-sheet">
      <button type="button" class="close-btn" (click)="onClose()">
        <sc-icon name="close"></sc-icon>
        <span class="sr_only">{{
          'GlobalApplicativeConstants.accessibility.closeDialog'
            | translate
              : {
                  dialogTitle: getFirstSectionLegendKey() | translate
                }
        }}</span>
      </button>
    </div>

    <h1
      mat-dialog-title
      id="dossier-last-step-form-title-id"
      class="question-title sc-design-title-h2"
    >
      {{ getFirstSectionLegendKey() | translate }}
    </h1>

    <div class="last-step-form-container">
      <sc-dossier-last-step-form
        [currentDossier]="data.currentDossier"
        [currentFitter]="data.currentFitter"
        [isCallBack]="data.isCallBack"
        (bookClickEvent)="onBookClick($event)"
      ></sc-dossier-last-step-form>
    </div>
  `,
  imports: [DossierLastStepFormComponent, TranslateModule, IconComponent],
})
export class DossierLastStepFormBottomSheetComponent {
  public data: DossierLastStepFormBottomSheetData = inject(
    MAT_BOTTOM_SHEET_DATA
  );
  private readonly bottomSheetRef =
    inject<
      MatBottomSheetRef<
        DossierLastStepFormBottomSheetComponent,
        DossierLastStepForm
      >
    >(MatBottomSheetRef);

  getFirstSectionLegendKey() {
    return !this.data.isCallBack
      ? 'VerifyCustomerDataBottomSheet.questionTitle'
      : 'VerifyCustomerDataBottomSheet.mainTitle';
  }

  onBookClick(dossier: DossierLastStepForm) {
    this.bottomSheetRef.dismiss(dossier);
  }

  onClose() {
    this.bottomSheetRef.dismiss();
  }
}
